<template>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    :before-close="handleCancel"
    :title="title"
    class="restore-archiving-dialog common-dialog"
  >
    <div class="archiving-illustrate">
      <div>数据恢复说明：</div>
      <div>1）数据恢复为连续恢复；</div>
      <div>2）未归档块高无法恢复；</div>
    </div>
    <el-form
      ref="dataForm"
      :model="dataForm"
      :rules="rules"
      :label-width="`${adaptationVars.formLabelWidth}px`"
      class="restore-archiving-form"
    >
      <el-form-item label="数据库IP" prop="ip">
        <el-input v-model="dataForm.ip" placeholder="请输入数据库IP"></el-input>
      </el-form-item>
      <el-form-item label="数据库端口" prop="port">
        <el-input v-model="dataForm.port" placeholder="请输入数据库端口"></el-input>
      </el-form-item>
      <el-form-item label="数据库用户名" prop="user">
        <el-input v-model="dataForm.user" placeholder="请输入数据库用户名"></el-input>
      </el-form-item>
      <el-form-item label="数据库密码" prop="pwd">
        <el-input v-model="dataForm.pwd" show-password placeholder="请输入数据库密码"></el-input>
      </el-form-item>
      <el-form-item label="数据恢复至区块高度" prop="height">
        <el-input-number
          v-model="dataForm.height"
          controls-position="right"
          :min="0"
          :max="totalArchivingHeight"
        ></el-input-number>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <div>
        <el-button @click="handleCancel()">取消</el-button>
        <el-button
          v-loading.fullscreen.lock="fullscreenLoading"
          type="primary"
          @click="submitForm()"
          >立即恢复</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script>
import adaptation from '@/mixins/adaptation'
export default {
  name: 'ArchivingRestore',
  mixins: [adaptation],
  adaptationVarsDefine: {
    formLabelWidth: 120
  },
  props: {
    totalArchivingHeight: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      title: '归档数据恢复',
      dialogVisible: false,
      dataForm: {
        chainid: '',
        ip: '',
        port: '',
        blocks: '',
        user: '',
        pwd: '',
        time: '',
        height: null
      },
      rules: {
        ip: [
          { required: true, message: '请输入数据库IP', trigger: ['blur', 'change'] },
          {
            pattern: /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/,
            message: '请输入有效的IP地址',
            trigger: ['blur', 'change']
          }
        ],
        port: [
          { required: true, message: '请输入数据库端口', trigger: ['blur', 'change'] },
          { pattern: /^[1-9]\d{0,4}$/, message: '请输入有效的端口 ', trigger: ['blur', 'change'] }
        ],
        user: [{ required: true, message: '请输入数据库用户名', trigger: ['blur', 'change'] }],
        pwd: [{ required: true, message: '请输入数据库密码', trigger: ['blur', 'change'] }]
      },
      fullscreenLoading: false,
      adaptationVars: {
        formLabelWidth: 120
      }
    }
  },
  mounted() {},
  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    handleOpen() {
      let sInfoStr = localStorage.getItem('cbaas_blockchain_archiving_server')
      let sInfo = {}
      if (sInfoStr) {
        try {
          sInfo = JSON.parse(sInfoStr)
        } catch (e) {
          console.log(e)
        }
      }
      this.dataForm = {
        ip: sInfo.ip,
        port: sInfo.port,
        blocks: '',
        user: sInfo.user,
        pwd: sInfo.pwd,
        time: '',
        height: null
      }
      this.dialogVisible = true
    },
    submitForm() {
      let self = this
      this.$refs['dataForm'].validate(valid => {
        if (valid) {
          console.log('submit!!')
          self.fullscreenLoading = true
          let params = {
            restore_height: self.dataForm.height,
            blocks: 10000,
            chainid: self.$route.query.chainId,
            secret_key: self.$route.query.chainId,
            db_info: {
              ip: self.dataForm.ip,
              port: self.dataForm.port,
              user: self.dataForm.user,
              pwd: self.dataForm.pwd
            }
          }
          localStorage.setItem('cbaas_blockchain_archiving_server', JSON.stringify(params.db_info))
          self.$apis.chain
            .restore(params)
            .then(data => {
              self.fullscreenLoading = false
              if (!data.errors) {
                self.dialogVisible = false
                self.$message.success('恢复成功')
                self.$emit('restoreSuccess')
              }
            })
            .catch(err => {
              self.fullscreenLoading = false
              console.log(err)
            })
        } else {
          console.log('error submit!!')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'restore-archiving-dialog',
  (
    --restore-archiving-dialog-illustrate-border-color: #4b5471
  ),
  (
    --restore-archiving-dialog-illustrate-border-color: #ebebeb
  )
);

.restore-archiving-dialog.common-dialog {
  @include adaptation(
    (
      --restore-archiving-dialog-body-padding: 40px 40px 0px 40px,
      --restore-archiving-dialog-illustrate-padding: 15px 10px 10px 40px,
      --restore-archiving-dialog-illustrate-height: 100px,
      --restore-archiving-dialog-illustrate-border-width: 1px,
      --restore-archiving-dialog-illustrate-border-radius: 6px,
      --restore-archiving-dialog-illustrate-font-size: 14px,
      --restore-archiving-dialog-illustrate-line-height: 22px,
      --restore-archiving-dialog-form-margin-top: 20px,
      --restore-archiving-dialog-form-margin-right: 30px
    )
  );

  /deep/ .el-dialog {
    width: var(--common-dialog-large-width);
  }

  /deep/ .el-dialog__body {
    padding: var(--restore-archiving-dialog-body-padding);

    .archiving-illustrate {
      width: 100%;
      padding: var(--restore-archiving-dialog-illustrate-padding);
      height: var(--restore-archiving-dialog-illustrate-height);
      margin: 0 auto;
      border: var(--restore-archiving-dialog-illustrate-border-width) dashed
        var(--restore-archiving-dialog-illustrate-border-color);
      border-radius: var(--restore-archiving-dialog-illustrate-border-radius);
      font-size: var(--restore-archiving-dialog-illustrate-font-size);
      line-height: var(--restore-archiving-dialog-illustrate-line-height);
    }

    .restore-archiving-form {
      margin-top: var(--restore-archiving-dialog-form-margin-top);
      margin-right: var(--restore-archiving-dialog-form-margin-right);
    }
  }
}
</style>
